<template>
  <template v-if="Identity.Claims.container == props.tenant">
    <slot></slot>
  </template>
</template>
  
<script setup lang="ts">
import { useIdentity } from '../../features/identity';

interface IComponentProps {
  tenant: string
}

const props: IComponentProps = defineProps<IComponentProps>()

const { Identity } = useIdentity();

</script>
  